<nav class="horizontal-menu">
	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.stockManager()">
		<mat-icon>bar_chart</mat-icon>
		{{ 'admin_console.stock_management' | translate }}
	</a>
	<!-- <a mat-raised-button>
		<mat-icon>settings</mat-icon>
		{{ 'admin_console.machine' | translate }}
	</a>
	<a mat-raised-button>
		<mat-icon>print</mat-icon>
		{{ 'admin_console.printer_settings' | translate }}
	</a> -->
	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.openingHours()">
		<mat-icon>access_time</mat-icon>
		{{ 'admin_console.opening_hours' | translate }}
	</a>
	<a mat-raised-button (click)="openDialog()">
		<mat-icon>settings</mat-icon>
		Printer Settings
	</a>
	<a mat-raised-button [routerLink]="'/' + urlLinkEnum.timeSettings()">
		<mat-icon>settings</mat-icon>
		{{ 'admin_console.time_settings' | translate }}
	</a>

	@if (venueValue$ | async; as venue) {
	<a
		mat-raised-button
		class="button-delivery"
		(click)="updateUber()"
		*ngIf="checkIfSetupOrderProviders(venue, 'uber_eat')"
	>
		<div>
			<img src="../assets/uber_eats.png" class="logo" height="15" />
			@if (isVenueOpen$ | async) { @if (isUberEatsActiveInVenue$ | async; as
			valueWolt) {
			<h3 class="green">{{ 'common.online' | translate }}</h3>
			} @else {
			<h3 class="red">
				{{ 'common.offline' | translate }}
				<p *ngIf="venue.externalOrderProviders?.uberEats?.snoozed">
					bis:
					{{
						venue.externalOrderProviders.uberEats?.snoozed | date: 'HH:mm dd.MM'
					}}
				</p>
			</h3>
			} } @else {
			<h3 class="red">!!{{ 'common.closed' | translate }}</h3>
			}
		</div>
	</a>

	<a
		*ngIf="checkIfSetupOrderProviders(venue, 'wolt')"
		mat-raised-button
		class="button-delivery last-btn"
		(click)="updateWolt()"
	>
		<div>
			<img src="../assets/wolt.svg" class="logo" height="18" />
			@if (isVenueOpen$ | async) { @if (isWoltActiveInVenue$ | async; as
			valueWolt) {
			<h3 class="green">{{ 'common.online' | translate }}</h3>
			} @else {
			<h3 class="red">
				{{ 'common.offline' | translate }} <br />
				<p *ngIf="venue.externalOrderProviders?.wolt?.snoozed">
					bis:
					{{ venue.externalOrderProviders.wolt?.snoozed | date: 'HH:mm dd.MM' }}
				</p>
			</h3>
			} } @else {
			<h3 class="red">{{ 'common.closed' | translate }}</h3>
			}
		</div>
	</a>

	<a
		*ngIf="checkIfSetupOrderProviders(venue, 'jet')"
		mat-raised-button
		class="button-delivery"
		href="https://restaurants.takeaway.com"
		target="_blank"
	>
		<div>
			<img src="../assets/lieferando.png" class="logo" height="15" />
			<h3 class="text_small">
				{{ 'admin_console.delivery_info' | translate }}
			</h3>
		</div>
	</a>
	}

	<a mat-raised-button (click)="logout()" class="out-color">
		<mat-icon>logout</mat-icon>
		{{ 'common.logout' | translate }}
	</a>
</nav>
